/*
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-07-11 11:16:25
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-07-11 11:41:08
 */
import { defineStore } from 'pinia'

export const useRiskWordAppealStore = defineStore('risk-word-appeal-store', {
  state: () => {
    return {
      /** Boolean 是否显示风险词弹窗 */
      showRiskWordAppealModal: false,
      /** string[] 风险词词组 */
      riskWords: []
    }
  },
  actions: {
    /** 设置是否显示风险词弹窗 */
    updateRiskWordAppealModal(isShow: boolean) {
      this.showRiskWordAppealModal = isShow
    },
    /** 设置风险词词组 */
    updateRiskWords(words: string[]) {
      this.riskWords = words || []
    }
  },
  getters: {
    /** 是否显示风险词弹窗 */
    isShowRiskWordAppealModal: (state) => state.showRiskWordAppealModal,
    /** 风险词词组 */
    riskWordsList: (state) => state.riskWords
  }
})